import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from '@material-ui/core';
import { Button, Typography } from 'kangarootime-ui';
import CenterSwitcher from './CenterSwitcher';

const ProfileDropdownMenu = ({ anchorEl, handleDismiss, logout, centerSwitcher }) => {
  return (
    <Menu
      anchorEl={anchorEl}
      getContentAnchorEl={null}
      open={Boolean(anchorEl)}
      onClose={handleDismiss}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <div style={{ padding: 8 }}>
        <div style={{ justifyContent: 'center' }}>
          <Typography type='meta'>Current Center</Typography>
          <CenterSwitcher
            centerId={centerSwitcher.centerId}
            centers={centerSwitcher.centers}
            onSwitch={centerSwitcher.switchCenter}
          />
        </div>
        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <Button type='secondary' onClick={logout}>Logout</Button>
        </div>
      </div>
    </Menu>
  );
};

ProfileDropdownMenu.propTypes = {
  anchorEl: PropTypes.object,
  handleDismiss: PropTypes.func,
  logout: PropTypes.func,
  centerSwitcher: PropTypes.shape({
    centerId: PropTypes.number,
    centers: PropTypes.array,
    switchCenter: PropTypes.func
  })
};

export default ProfileDropdownMenu;
